module.exports = __webpack_public_path__ + "static/img/vio_ban_pt.e9c00a48.png";